import { Component } from '@angular/core';
import { AlertService, AuthService } from '@app/core/services';
import { BaseContextmenuComponent } from './base-contextmenu.component';


@Component({
  selector: 'role-contextmenu',
  template: `
    <kendo-contextmenu (select)="onSelect($event)">
      <kendo-menu-item url="detalle">
        <ng-template kendoMenuItemTemplate let-item="item">
          <div class="menu-header">
            <span class="k-icon k-i-information"></span>
            Rol: {{contextItem.name}}
          </div>
        </ng-template>
      </kendo-menu-item>
      <kendo-menu-item url="editar" text="Editar" icon="edit" *ngIf="this.authService.hasPermission(['ROLES:EDITAR'])"></kendo-menu-item>
      <kendo-menu-item url="eliminar" text="Eliminar" icon="trash" *ngIf="this.authService.hasPermission(['ROLES:ELIMINAR'])"></kendo-menu-item>
      <kendo-menu-item [separator]="true"></kendo-menu-item>
      <kendo-menu-item url="permisos" text="Permisos" icon="txt" *ngIf="this.authService.hasPermission(['ROLES:EDITAR'])"></kendo-menu-item>
    </kendo-contextmenu>`,
  styles: [`
    .menu-header {
      color: #ff6358
    }
  `]
})
export class RoleContextmenuComponent extends BaseContextmenuComponent {  

  //Overrides
  constructor(protected authService: AuthService, protected alertService: AlertService) {
            
    super(authService, alertService);
    // console.log(this.constructor.name);   
    
  }

  //Overrides
  protected onSelect(event): void {

    // console.log(this.constructor.name + ":onSelect", event.item, this.contextItem);
    
    event.preventDefault();
    let url: string = event.item.url;

    if (url === 'editar') {

      // Editar

    } else if (url === 'eliminar') {
        
      // Eliminar

    } else if (url === 'permisos') {

      // Permisos

    }

    //Emitir evento: selected
    this.select.emit({menu: event.item, contextItem: this.contextItem});

  }

}
